module.exports = __webpack_public_path__ + "static/media/smart_welcome_icon.d27fc687.svg";